module.exports = __webpack_public_path__ + "static/media/YF74_02.7a4bf8f5.jpg";